<template>
	<div class="teamrole-feedback stage" :style="{ 'background-image': backgroundImage }">

		<div class="header__container">
			<div class="subHeader" style="position: relative">
				{{roundData.questions.feedback[0].subheader}}
			</div>
			<div class="header" style="position: relative">
				{{roundData.questions.feedback[0].header}}
			</div>
			<div class="text text-top" style="position: relative">{{roundData.questions.feedback[0].feedbacktext}}</div>
		</div>
		<div class="explanation mainTitle" style="position: relative"/>

            <div class="teamrole__button not-active">
		      <div class="visual"><img :src="baseUrl + questionData.answers[feedbackData.answer].visual"/></div>
		      <div class="content"><span class="title">{{questionData.answers[feedbackData.answer].title}}</span><br>{{questionData.answers[feedbackData.answer].answer_text}}</div>
	       </div>

		<div class="panel" style="position: relative">

			<div class="header">{{questionData.answers[feedbackData.answer].info_header}}</div>
			{{questionData.answers[feedbackData.answer].info_text}}

		</div>

	</div>
</template>

<script>

	import Lottie from '../../../Lottie.vue';
	import { url} from '../../../../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		components:{
			Lottie,
		},

		beforeMount(){
			
		},

		mounted(){
			setTimeout(()=>{
				this.setNextButtonAction(this.lastRound ? this.toNextStage : this.toNextRound).then(()=>{
					this.showNextButton();
				});
			},500);
		},

		data(){
			return {
				baseUrl : url,
				feedbackArray : []
			}
		},
		methods:{
			...mapActions([
				"setNextButtonAction",
				"showNextButton",
				"toNextStage",
				"toNextRound"
			]),

		},
		computed:{
			...mapGetters([
				"questionData",
				"feedbackData",
				"lastRound",
				'roundData',
			]),

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/feedback/teamrole/Index.vue